export default __webpack_public_path__ + "static/media/Snd1.7740b164.mp3";